import React from "react";
import { IListViewField } from "src/components/Shared/ILIstViewField";
import { DocumentListViewDefaultToolbarButtons } from "src/components/Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { DocumentListViewToolbar } from "src/components/Shared/ListViews/DocumentListViewToolbar";
import { ListView } from "src/components/Shared/ListViews/ListView";
import { ListviewToolbarMoreActions } from "src/components/Shared/ListViews/ListviewToolbarMoreActions";
import { AppEntities } from "src/config/entities";

const TransferOfGoodsList = () => {
  const fields: IListViewField[] = [
    {
      fieldName: "companyName",
      title: "Company",
      fieldType: "string"
    },
    {
      fieldName: "sourceWarehouseName",
      title: "Source",
      fieldType: "string"
    },
    {
      fieldName: "destinationWarehouseName",
      title: "Destination",
      fieldType: "string"
    }
  ];

  return (
    <>
      <ListView
        // createDocumentActions={createDocumentActions}
        fields={fields}
        entity={AppEntities.TransferOfGoods}
        // createDependedDocumentActions={createDocumentActions}
        createMoreActions={[]}
      >
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons />
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>{" "}
    </>
  );
};

export default TransferOfGoodsList;
